GamesPage 		= require './pages/GamesPage'
NewGamePage 	= require './pages/NewGamePage'
GamePage 		= require './pages/GamePage'
RoundPage 		= require './pages/RoundPage'
SettingsPage 	= require './pages/SettingsPage'
DataPage 		= require './pages/DataPage'

module.exports = {
	defaultRoute: '/'
	generate: (store) -> {
		'/': GamesPage store
		'/newgame': NewGamePage store
		'/game/:id': GamePage store
		'/game/:id/:round': RoundPage store
		'/settings': SettingsPage store
		'/settings/data': DataPage store
	}
}